// Case/NewCasesPage.tsx
import { CasesListView } from '../Cases/Components/CasesListView';
import { CASE_STATUS } from '../caseStatusIds';

/** Admin view of every case that has been opened but not yet assigned to a leader. */
export default function NewCasesPage() {
  return (
    <CasesListView
      fixedStatusID={CASE_STATUS.New}
      title="New Cases"
      subtitle="Cases opened, not yet assigned"
    />
  );
}
